/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/article-carousel.js":
/*!*******************************************!*\
  !*** ./js/components/article-carousel.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules */ "./node_modules/swiper/modules/index.mjs");


var _excluded = ["breakpoints"],
  _excluded2 = ["pagination", "navigation", "linked", "scrollBar"],
  _excluded3 = ["navigation", "pagination", "progressPagination", "scrollBar", "linked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


class ArticleCarousel extends HTMLElement {
  constructor() {
    super();
    this.carouselSettings;
    this.currentWidth;
    this.innerHTML;
    this.container;
  }
  connectedCallback() {
    if (this.innerHTML.length > 0) {
      this.initCarousel();
    } else {
      var that = this;
      var checkHtmlLength = window.setInterval(() => {
        if (this.innerHTML.length > 0) {
          that.initCarousel();
          window.clearInterval(checkHtmlLength);
          checkHtmlLength = false;
        }
      }, 500);
      window.setTimeout(() => {
        if (checkHtmlLength) {
          window.clearInterval(checkHtmlLength);
        }
      }, 5000);
    }
  }
  getCarouselSettings() {
    this.currentWidth = window.innerWidth;
    var parent = this.closest('[data-parent]') || this;
    //default settings
    var defaultSettings = {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 1000,
      navigation: false
    };
    var carouselSettings = defaultSettings;
    //end of default settings 

    //handle breakpoint
    var _this$carouselSetting = this.carouselSettings,
      {
        breakpoints
      } = _this$carouselSetting,
      otherSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting, _excluded);
    if (breakpoints) {
      this.breakpoints = Object.keys(breakpoints);
      this.breakpoints.forEach((breakpoint, index) => {
        if (this.currentWidth >= breakpoint) {
          if (breakpoints[breakpoint]) {
            this.breakpointSettings = breakpoints[breakpoint];
          } else {
            this.breakpointSettings = breakpoints[this.breakpoints[index - 1]];
          }
          var _this$breakpointSetti = this.breakpointSettings,
            {
              pagination,
              navigation,
              linked,
              scrollBar
            } = _this$breakpointSetti,
            otherResponsiveSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$breakpointSetti, _excluded2);
          this.carouselSettings = _objectSpread(_objectSpread(_objectSpread({}, otherSettings), otherResponsiveSettings), {}, {
            pagination,
            navigation,
            linked
          });
        }
      });
    }
    if (this.carouselSettings && Object.keys(this.carouselSettings).length > 0) {
      var _this$carouselSetting2 = this.carouselSettings,
        {
          navigation,
          pagination,
          progressPagination,
          scrollBar,
          linked
        } = _this$carouselSetting2,
        otherSwiperSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting2, _excluded3);
      var _parent = this.closest('[data-parent]') || this;
      carouselSettings = _objectSpread({}, otherSwiperSettings);
      if (navigation) {
        var navigationNext = _parent.querySelector('.swiper-navigation--next');
        var navigationPrev = _parent.querySelector('.swiper-navigation--prev');
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          navigation: {
            nextEl: navigationNext,
            prevEl: navigationPrev
          }
        });
      }
      if (pagination) {
        var swiperPagination = _parent.querySelector('.swiper-pagination');
        var paginationConfig = {
          el: swiperPagination,
          clickable: true
        };

        // Handle progressbar pagination
        if (progressPagination) {
          paginationConfig.type = 'progressbar';
        }
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          pagination: paginationConfig
        });
      }
      if (linked) {
        carouselSettings.linked = linked;
      }
      if (scrollBar) {
        var _scrollBar = this.querySelector('.swiper-scrollbar');
        carouselSettings.scrollbar = {
          el: _scrollBar,
          draggable: true,
          // Snaps slider position to slides when you release Scrollbar
          snapOnRelease: true,
          // Size (Length) of Scrollbar Draggable Element in px
          dragSize: 'auto'
        };
      }
    }
    return carouselSettings;
  }
  initCarousel() {
    var _this$querySelector, _this$querySelector2, _this$querySelector3;
    var parent = this.closest('[data-parent]') || this;
    this.carouselSettings = JSON.parse(((_this$querySelector = this.querySelector('[data-settings]')) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.innerHTML) || "{}");
    this.carouselContent = (_this$querySelector2 = this.querySelector('[data-carousel-content]')) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.innerHTML;
    this.placeholders = (_this$querySelector3 = this.querySelector('[data-carousel-placeholder]')) === null || _this$querySelector3 === void 0 ? void 0 : _this$querySelector3.innerHTML;
    this.navigations = parent.querySelector('[data-swiper-navigations]');
    this.currentWidth = window.innerWidth;
    window.carousels = window.carousels || {};

    // Check if container already exists (from snippet)
    this.container = this.querySelector('[data-swiper-container]');
    var containerExists = !!this.container;

    // Generate unique IDs for SVGs to avoid conflicts
    var uniqueId = Math.random().toString(36).substr(2, 9);

    // Article carousel uses the same blue SVG for both buttons (previous button style)
    var swiperNavigationElements = this.carouselSettings.useArrowSymbols ? "\n      <div class=\"swiper-navigation swiper-navigation--next ".concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_300_next_").concat(uniqueId, ")\">\n            <mask id=\"mask0_12755_300_next_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M0.441338 0.0195312H25.5576V25.1358H0.441338V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_300_next_").concat(uniqueId, ")\">\n              <path d=\"M9.07031 2.16504C9.42505 1.79359 10.0142 1.78014 10.3857 2.13477L20.6182 11.9023V11.9023C21.0021 12.2687 21.0021 12.8816 20.6182 13.248V13.248L10.3857 23.0156C10.0141 23.3701 9.42496 23.3559 9.07031 22.9844C8.71601 22.6129 8.72961 22.0246 9.10059 21.6699L17.923 13.2481C18.3069 12.8816 18.3069 12.2688 17.923 11.9023L9.10059 3.48047C8.72927 3.1258 8.71593 2.53661 9.07031 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_300_next_").concat(uniqueId, "\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"translate(0.441406 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n      <div class=\"swiper-navigation swiper-navigation--prev ").concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_300_prev_").concat(uniqueId, ")\">\n            <mask id=\"mask0_12755_300_prev_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M0.441338 0.0195312H25.5576V25.1358H0.441338V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_300_prev_").concat(uniqueId, ")\">\n              <path d=\"M16.9297 2.16504C16.575 1.79359 15.9858 1.78014 15.6143 2.13477L5.38184 11.9023V11.9023C4.99788 12.2687 4.99788 12.8816 5.38184 13.248V13.248L15.6143 23.0156C15.9859 23.3701 16.575 23.3559 16.9297 22.9844C17.284 22.6129 17.2704 22.0246 16.8994 21.6699L8.07695 13.2481C7.69307 12.8816 7.69307 12.2688 8.07695 11.9023L16.8994 3.48047C17.2707 3.1258 17.2841 2.53661 16.9297 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_300_prev_").concat(uniqueId, "\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"matrix(-1 0 0 1 25.5586 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n    ") : "\n      <div class=\"swiper-navigation swiper-navigation--next ".concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_300_next_").concat(uniqueId, ")\">\n            <mask id=\"mask0_12755_300_next_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M0.441338 0.0195312H25.5576V25.1358H0.441338V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_300_next_").concat(uniqueId, ")\">\n              <path d=\"M9.07031 2.16504C9.42505 1.79359 10.0142 1.78014 10.3857 2.13477L20.6182 11.9023V11.9023C21.0021 12.2687 21.0021 12.8816 20.6182 13.248V13.248L10.3857 23.0156C10.0141 23.3701 9.42496 23.3559 9.07031 22.9844C8.71601 22.6129 8.72961 22.0246 9.10059 21.6699L17.923 13.2481C18.3069 12.8816 18.3069 12.2688 17.923 11.9023L9.10059 3.48047C8.72927 3.1258 8.71593 2.53661 9.07031 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_300_next_").concat(uniqueId, "\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"translate(0.441406 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n      <div class=\"swiper-navigation swiper-navigation--prev ").concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_300_prev_").concat(uniqueId, ")\">\n            <mask id=\"mask0_12755_300_prev_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M0.441338 0.0195312H25.5576V25.1358H0.441338V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_300_prev_").concat(uniqueId, ")\">\n              <path d=\"M16.9297 2.16504C16.575 1.79359 15.9858 1.78014 15.6143 2.13477L5.38184 11.9023V11.9023C4.99788 12.2687 4.99788 12.8816 5.38184 13.248V13.248L15.6143 23.0156C15.9859 23.3701 16.575 23.3559 16.9297 22.9844C17.284 22.6129 17.2704 22.0246 16.8994 21.6699L8.07695 13.2481C7.69307 12.8816 7.69307 12.2688 8.07695 11.9023L16.8994 3.48047C17.2707 3.1258 17.2841 2.53661 16.9297 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_300_prev_").concat(uniqueId, "\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"matrix(-1 0 0 1 25.5586 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n    ");

    // If container already exists (from snippet), use it; otherwise create new structure
    if (!containerExists) {
      this.carouselContent ? this.innerHTML = "<div class=\"carousel__container swiper hide\" data-swiper-container>\n      <div class=\"swiper-wrapper\">\n      ".concat(this.carouselContent, "\n      </div> </div>\n      <div class=\"swiper-pagination\"></div>\n      ").concat(this.carouselSettings['customNavigation'] ? '' : swiperNavigationElements, "\n      ").concat(this.placeholders ? this.placeholders : "<div class=\"carousel-placeholders\"></div>") : this.innerHTML = "<div class=\"carousel__container swiper hide\" data-swiper-container>\n      <div class=\"swiper-wrapper\"></div>\n      </div>\n      <div class=\"swiper-pagination\"></div>\n      ".concat(this.carouselSettings['customNavigation'] ? '' : swiperNavigationElements, "\n      ").concat(this.placeholders ? this.placeholders : "<div class=\"carousel-placeholders\"></div>");
    } else {
      // Container exists, add navigation to the external navigation container
      if (this.carouselSettings['customNavigation'] && this.navigations) {
        this.navigations.innerHTML = swiperNavigationElements;
      } else if (!this.carouselSettings['customNavigation']) {
        // If not custom navigation, add to the navigations div if it exists
        if (this.navigations) {
          this.navigations.innerHTML = swiperNavigationElements;
        }
      }
    }
    this.container = this.querySelector('[data-swiper-container]');
    var carouselSettings = this.getCarouselSettings();
    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](this.container, _objectSpread({
      on: {
        beforeInit: swiper => {
          var parent = this.closest('[data-parent]') || this;
          var {
            navigation,
            pagination,
            linked
          } = carouselSettings || {};
          if (!navigation) {
            parent.querySelectorAll('.swiper-navigation').forEach(navigation => navigation.classList.add('swiper-navigation--hide'));
          } else {
            parent.querySelector('.swiper-navigation--hide') && this.querySelectorAll('.swiper-navigation--hide').forEach(navigation => navigation.classList.remove("swiper-pagination--hide"));
          }
          if (pagination) {
            var _parent2 = this.closest('[data-parent]') || this;
            _parent2.querySelectorAll('.swiper-pagination').forEach(navigation => navigation.classList.remove('swiper-pagination--hide'));
          }
          var name = this.carouselSettings.name;
          if (name) {
            window.carousels = window.carousels || {};
            window.carousels["".concat(name)] = swiper;
          }
        },
        afterInit: () => {
          var _this$querySelector4;
          var container = this.querySelector('.carousel__container');
          if (container) {
            container.classList.remove('hide');
          }
          (_this$querySelector4 = this.querySelector('.carousel-placeholders')) === null || _this$querySelector4 === void 0 || _this$querySelector4.classList.add('hide');
        }
      },
      modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.EffectFade, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Autoplay, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Controller]
    }, carouselSettings));
    var isLinked = false;
    this.swiper.on('beforeSlideChangeStart', current => {
      if (!isLinked) {
        var linkedSlider = window.carousels["".concat(this.carouselSettings.linked)];
        current.controller.control = linkedSlider;
        isLinked = true;
      }
    });
    this.swiper.on('activeIndexChange', current => {
      var _this$querySelector5, _this$querySelectorAl;
      (_this$querySelector5 = this.querySelector('.swiper-pagination-bullet-active')) === null || _this$querySelector5 === void 0 || _this$querySelector5.classList.remove('swiper-pagination-bullet-active');
      (_this$querySelectorAl = this.querySelectorAll('.swiper-pagination-bullet')[current.activeIndex]) === null || _this$querySelectorAl === void 0 || _this$querySelectorAl.classList.add('swiper-pagination-bullet-active');
    });
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArticleCarousel);

/***/ }),

/***/ "./js/components/custom-carousel.js":
/*!******************************************!*\
  !*** ./js/components/custom-carousel.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules */ "./node_modules/swiper/modules/index.mjs");


var _excluded = ["breakpoints"],
  _excluded2 = ["pagination", "navigation", "linked", "scrollBar"],
  _excluded3 = ["navigation", "pagination", "progressPagination", "scrollBar", "linked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


class CustomCarousel extends HTMLElement {
  constructor() {
    super();
    this.carouselSettings;
    this.currentWidth;
    this.innerHTML;
    this.container;
  }
  connectedCallback() {
    if (this.innerHTML.length > 0) {
      this.initCarousel();
    } else {
      var that = this;
      var checkHtmlLength = window.setInterval(() => {
        if (this.innerHTML.length > 0) {
          that.initCarousel();
          window.clearInterval(checkHtmlLength);
          checkHtmlLength = false;
        }
      }, 500);
      window.setTimeout(() => {
        if (checkHtmlLength) {
          window.clearInterval(checkHtmlLength);
        }
      }, 5000);
    }
  }
  getCarouselSettings() {
    this.currentWidth = window.innerWidth;
    var parent = this.closest('[data-parent]') || this;
    //default settings
    var defaultSettings = {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 1000,
      navigation: false
    };
    var carouselSettings = defaultSettings;
    //end of default settings 

    //handle breakpoint
    var _this$carouselSetting = this.carouselSettings,
      {
        breakpoints
      } = _this$carouselSetting,
      otherSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting, _excluded);
    if (breakpoints) {
      this.breakpoints = Object.keys(breakpoints);
      this.breakpoints.forEach((breakpoint, index) => {
        if (this.currentWidth >= breakpoint) {
          if (breakpoints[breakpoint]) {
            this.breakpointSettings = breakpoints[breakpoint];
          } else {
            this.breakpointSettings = breakpoints[this.breakpoints[index - 1]];
          }
          var _this$breakpointSetti = this.breakpointSettings,
            {
              pagination,
              navigation,
              linked,
              scrollBar
            } = _this$breakpointSetti,
            otherResponsiveSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$breakpointSetti, _excluded2);
          this.carouselSettings = _objectSpread(_objectSpread(_objectSpread({}, otherSettings), otherResponsiveSettings), {}, {
            pagination,
            navigation,
            linked
          });
        }
      });
    }
    if (this.carouselSettings && Object.keys(this.carouselSettings).length > 0) {
      var _this$carouselSetting2 = this.carouselSettings,
        {
          navigation,
          pagination,
          progressPagination,
          scrollBar,
          linked
        } = _this$carouselSetting2,
        otherSwiperSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting2, _excluded3);
      var _parent = this.closest('[data-parent]') || this;
      carouselSettings = _objectSpread({}, otherSwiperSettings);
      if (navigation) {
        var navigationNext = _parent.querySelector('.swiper-navigation--next');
        var navigationPrev = _parent.querySelector('.swiper-navigation--prev');
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          navigation: {
            nextEl: navigationNext,
            prevEl: navigationPrev
          }
        });
      }
      if (pagination) {
        var swiperPagination = _parent.querySelector('.swiper-pagination');
        var paginationConfig = {
          el: swiperPagination,
          clickable: true
        };

        // Handle progressbar pagination
        if (progressPagination) {
          paginationConfig.type = 'progressbar';
        }
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          pagination: paginationConfig
        });
      }
      if (linked) {
        carouselSettings.linked = linked;
      }
      if (scrollBar) {
        var _scrollBar = this.querySelector('.swiper-scrollbar');
        carouselSettings.scrollbar = {
          el: _scrollBar,
          draggable: true,
          // Snaps slider position to slides when you release Scrollbar
          snapOnRelease: true,
          // Size (Length) of Scrollbar Draggable Element in px
          dragSize: 'auto'
        };
      }
    }
    return carouselSettings;
  }
  initCarousel() {
    var _this$querySelector, _this$querySelector2, _this$querySelector3;
    var parent = this.closest('[data-parent]') || this;
    this.carouselSettings = JSON.parse(((_this$querySelector = this.querySelector('[data-settings]')) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.innerHTML) || "{}");
    this.carouselContent = (_this$querySelector2 = this.querySelector('[data-carousel-content]')) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.innerHTML;
    this.placeholders = (_this$querySelector3 = this.querySelector('[data-carousel-placeholder]')) === null || _this$querySelector3 === void 0 ? void 0 : _this$querySelector3.innerHTML;
    this.navigations = parent.querySelector('[data-swiper-navigations]');
    this.currentWidth = window.innerWidth;
    window.carousels = window.carousels || {};

    // Check if this is a banner-carousel
    var isBannerCarousel = parent.classList.contains('carousel-banner--desktop') || parent.classList.contains('carousel-banner--mobile') || parent.closest('.carousel-banner__wrapper') !== null || parent.closest('.banner-carousel') !== null;

    // Generate unique IDs for SVGs to avoid conflicts
    var uniqueId = Math.random().toString(36).substr(2, 9);
    var swiperNavigationElements = this.carouselSettings.useArrowSymbols ? "\n      <div class=\"swiper-navigation swiper-navigation--next ".concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_11)\">\n            <mask id=\"mask0_12755_11\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M25.5587 0.0195312H0.442383V25.1358H25.5587V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_11)\">\n              <path d=\"M9.07031 2.16504C9.42505 1.79359 10.0142 1.78014 10.3857 2.13477L20.6182 11.9023V11.9023C21.0021 12.2687 21.0021 12.8816 20.6182 13.248V13.248L10.3857 23.0156C10.0141 23.3701 9.42496 23.3559 9.07031 22.9844C8.71601 22.6129 8.72961 22.0246 9.10059 21.6699L17.923 13.2481C18.3069 12.8816 18.3069 12.2688 17.923 11.9023L9.10059 3.48047C8.72927 3.1258 8.71593 2.53661 9.07031 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_11\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"translate(0.441406 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n      <div class=\"swiper-navigation swiper-navigation--prev ").concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_300)\">\n            <mask id=\"mask0_12755_300\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n              <path d=\"M0.441338 0.0195312H25.5576V25.1358H0.441338V0.0195312Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_300)\">\n              <path d=\"M16.9297 2.16504C16.575 1.79359 15.9858 1.78014 15.6143 2.13477L5.38184 11.9023V11.9023C4.99788 12.2687 4.99788 12.8816 5.38184 13.248V13.248L15.6143 23.0156C15.9859 23.3701 16.575 23.3559 16.9297 22.9844C17.284 22.6129 17.2704 22.0246 16.8994 21.6699L8.07695 13.2481C7.69307 12.8816 7.69307 12.2688 8.07695 11.9023L16.8994 3.48047C17.2707 3.1258 17.2841 2.53661 16.9297 2.16504Z\" fill=\"#3B55FB\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_300\">\n              <rect width=\"25.1163\" height=\"25.1163\" fill=\"white\" transform=\"matrix(-1 0 0 1 25.5586 0.0187988)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n      </div>\n    ") : "\n      <div class=\"swiper-navigation swiper-navigation--next ".concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n        ").concat(isBannerCarousel ? "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\n          <g clip-path=\"url(#clip0_277_48212_".concat(uniqueId, ")\">\n            <mask id=\"mask0_277_48212_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"-1\" width=\"32\" height=\"33\">\n              <path d=\"M31.3953 -0.000366211H0V31.395H31.3953V-0.000366211Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_277_48212_").concat(uniqueId, ")\">\n              <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.7238 2.62275C11.2004 2.12354 11.992 2.10511 12.4913 2.58173L25.2814 14.7907L25.3476 14.8539C25.8274 15.312 25.8274 16.078 25.3476 16.5361L25.2814 16.5993L12.4913 28.8093C11.992 29.2857 11.2004 29.2664 10.7238 28.7673C10.2474 28.268 10.2657 27.4773 10.7648 27.0007L21.7265 16.5361C22.2063 16.078 22.2063 15.312 21.7264 14.8539L10.7648 4.39032C10.2654 3.91364 10.2471 3.1221 10.7238 2.62275Z\" fill=\"white\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_277_48212_").concat(uniqueId, "\">\n              <rect width=\"31.3953\" height=\"31.3953\" fill=\"white\" transform=\"translate(0.302734 0.302246)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n        ") : "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\n          <g clip-path=\"url(#clip0_12755_2_".concat(uniqueId, ")\">\n            <mask id=\"mask0_12755_2_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"32\" height=\"32\">\n              <path d=\"M31.6981 0.301514H0.302734V31.6969H31.6981V0.301514Z\" fill=\"white\"/>\n            </mask>\n            <g mask=\"url(#mask0_12755_2_").concat(uniqueId, ")\">\n              <path d=\"M16.0013 28.1187L28.1209 15.9992M28.1209 15.9992L16.0013 3.87964M28.1209 15.9992H3.30469\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n            </g>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_12755_2_").concat(uniqueId, "\">\n              <rect width=\"31.3953\" height=\"31.3953\" fill=\"white\" transform=\"translate(0.302734 0.302246)\"/>\n            </clipPath>\n          </defs>\n        </svg>\n        "), "\n    </div>\n    <div class=\"swiper-navigation swiper-navigation--prev ").concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n      ").concat(isBannerCarousel ? "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\n        <g clip-path=\"url(#clip0_322_281_".concat(uniqueId, ")\">\n          <mask id=\"mask0_322_281_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"-1\" y=\"-1\" width=\"33\" height=\"33\">\n            <path d=\"M0.499842 0.499634V30.8951H30.8953V0.499634H0.499842Z\" fill=\"white\" stroke=\"white\"/>\n          </mask>\n          <g mask=\"url(#mask0_322_281_").concat(uniqueId, ")\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.6716 2.62275C20.1949 2.12354 19.4033 2.10511 18.904 2.58173L6.11398 14.7907L6.04775 14.8539C5.56792 15.312 5.56792 16.078 6.04775 16.5361L6.11398 16.5993L18.904 28.8093C19.4033 29.2857 20.1949 29.2664 20.6716 28.7673C21.1479 28.268 21.1296 27.4773 20.6306 27.0007L9.66887 16.5361C9.18903 16.078 9.18905 15.312 9.66891 14.8539L20.6306 4.39032C21.1299 3.91364 21.1483 3.1221 20.6716 2.62275Z\" fill=\"white\"/>\n          </g>\n        </g>\n        <defs>\n          <clipPath id=\"clip0_322_281_").concat(uniqueId, "\">\n            <rect width=\"31.3953\" height=\"31.3953\" fill=\"white\" transform=\"matrix(-1 0 0 1 31.6973 0.302246)\"/>\n          </clipPath>\n        </defs>\n      </svg>\n      ") : "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\n        <g clip-path=\"url(#clip0_12755_78_".concat(uniqueId, ")\">\n          <mask id=\"mask0_12755_78_").concat(uniqueId, "\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"32\" height=\"32\">\n            <path d=\"M0.301916 0.301514H31.6973V31.6969H0.301916V0.301514Z\" fill=\"white\"/>\n          </mask>\n          <g mask=\"url(#mask0_12755_78_").concat(uniqueId, ")\">\n            <path d=\"M15.9987 28.1187L3.87914 15.9992M3.87914 15.9992L15.9987 3.87964M3.87914 15.9992H28.6953\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n          </g>\n        </g>\n        <defs>\n          <clipPath id=\"clip0_12755_78_").concat(uniqueId, "\">\n            <rect width=\"31.3953\" height=\"31.3953\" fill=\"white\" transform=\"matrix(-1 0 0 1 31.6973 0.302246)\"/>\n          </clipPath>\n        </defs>\n      </svg>\n      "), "\n    </div>\n    ");

    // Check if container already exists (from snippet)
    this.container = this.querySelector('[data-swiper-container]');
    var containerExists = !!this.container;
    if (!containerExists) {
      // Container doesn't exist, create it
      this.carouselContent ? this.innerHTML = "<div class=\"carousel__container swiper hide\" data-swiper-container>\n      <div class=\"swiper-wrapper\">\n      ".concat(this.carouselContent, "\n      </div> </div>\n      <div class=\"swiper-pagination\"></div>\n      ").concat(this.carouselSettings['customNavigation'] ? '' : swiperNavigationElements, "\n      ").concat(this.placeholders ? this.placeholders : "<div class=\"carousel-placeholders\"></div>") : this.innerHTML = "<div class=\"carousel__container swiper hide\" data-swiper-container>\n      <div class=\"swiper-wrapper\"></div>\n      </div>\n      <div class=\"swiper-pagination\"></div>\n      ".concat(this.carouselSettings['customNavigation'] ? '' : swiperNavigationElements, "\n      ").concat(this.placeholders ? this.placeholders : "<div class=\"carousel-placeholders\"></div>");
    } else {
      // Container exists from snippet, ensure it's visible
      if (this.container) {
        this.container.classList.remove('hide');
      }

      // Add navigation to the external navigation container if it exists
      if (this.navigations) {
        this.navigations.innerHTML = swiperNavigationElements;
      }
    }

    // Ensure we have the container reference
    if (!this.container) {
      this.container = this.querySelector('[data-swiper-container]');
    }
    var carouselSettings = this.getCarouselSettings();
    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](this.container, _objectSpread({
      on: {
        beforeInit: swiper => {
          var parent = this.closest('[data-parent]') || this;
          var {
            navigation,
            pagination,
            linked
          } = carouselSettings || {};
          console.log(linked, "linked");
          if (!navigation) {
            parent.querySelectorAll('.swiper-navigation').forEach(navigation => navigation.classList.add('swiper-navigation--hide'));
          } else {
            parent.querySelector('.swiper-navigation--hide') && this.querySelectorAll('.swiper-navigation--hide').forEach(navigation => navigation.classList.remove("swiper-pagination--hide"));
          }
          if (pagination) {
            var _parent2 = this.closest('[data-parent]') || this;
            _parent2.querySelectorAll('.swiper-pagination').forEach(navigation => navigation.classList.remove('swiper-pagination--hide'));
          }
          var name = this.carouselSettings.name;
          if (name) {
            window.carousels = window.carousels || {};
            window.carousels["".concat(name)] = swiper;
          }
        },
        afterInit: () => {
          var _this$querySelector4;
          this.querySelector('.carousel__container').classList.remove('hide');
          (_this$querySelector4 = this.querySelector('.carousel-placeholders')) === null || _this$querySelector4 === void 0 || _this$querySelector4.classList.add('hide');
        }
      },
      modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.EffectFade, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Autoplay, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Controller]
    }, carouselSettings));
    var isLinked = false;
    this.swiper.on('beforeSlideChangeStart', current => {
      if (!isLinked) {
        var linkedSlider = window.carousels["".concat(this.carouselSettings.linked)];
        current.controller.control = linkedSlider;
        isLinked = true;
      }
    });
    this.swiper.on('activeIndexChange', current => {
      var _this$querySelector5, _this$querySelectorAl;
      (_this$querySelector5 = this.querySelector('.swiper-pagination-bullet-active')) === null || _this$querySelector5 === void 0 || _this$querySelector5.classList.remove('swiper-pagination-bullet-active');
      (_this$querySelectorAl = this.querySelectorAll('.swiper-pagination-bullet')[current.activeIndex]) === null || _this$querySelectorAl === void 0 || _this$querySelectorAl.classList.add('swiper-pagination-bullet-active');
    });
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomCarousel);

/***/ }),

/***/ "./js/components/megamenu-header.js":
/*!******************************************!*\
  !*** ./js/components/megamenu-header.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var drawer = () => {
  var hamburgerBtn = document.querySelector('.megamenu__hamburger-btn');
  var drawer = document.querySelector('.megamenu__drawer');
  var backBtns = drawer.querySelectorAll('.megamenu__back-btn');
  var linkLevelOne = drawer.querySelectorAll('.megamenu__level-1');
  var linkLevelTwo = drawer.querySelectorAll('.megamenu__drawer-level-2');
  var dropdowns = drawer.querySelectorAll('.megamenu__dropdown');
  var isDrawerOpen = false;
  if (!drawer) return;
  var toggleDrawer = isOpen => {
    isDrawerOpen = isOpen;
    drawer.classList.toggle('open', isOpen);
    document.body.classList.toggle('megamenu__no-mobile-scroll', isOpen);
    if (!isOpen) resetDrawer();
  };
  hamburgerBtn.addEventListener('click', () => {
    toggleDrawer(!isDrawerOpen);
  });
  backBtns.forEach(backBtn => {
    backBtn === null || backBtn === void 0 || backBtn.addEventListener('click', () => {
      var drawerContent = drawer.querySelector('.megamenu__drawer-content');
      if (!drawerContent) return;
      drawerContent.style.transform = 'translateX(0)';
      linkLevelTwo.forEach(item => item.style.transform = 'translateX(100%)');
      dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
    });
  });
  var handleString = string => {
    var _string$trim;
    return (string === null || string === void 0 || (_string$trim = string.trim()) === null || _string$trim === void 0 ? void 0 : _string$trim.toLowerCase()) || '';
  };
  linkLevelOne.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      var parentText = handleString(link.innerText);
      var targetLevelTwo = [...document.querySelectorAll('.megamenu__drawer-level-2')].find(el => {
        var _el$dataset;
        var parentDataSet = handleString(el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.parent);
        if (parentDataSet == parentText) {
          return el;
        }
      });
      if (targetLevelTwo) {
        drawer.querySelector('.megamenu__drawer-content').style.transform = 'translateX(-100%)';
        targetLevelTwo.style.transform = 'translateX(0)';
      } else {
        var _link = e.target.closest('a');
        if (_link) {
          window.location.href = _link.href;
        }
      }
    });
  });
  document.querySelectorAll('.megamenu__level-2').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      var listItem = e.target.closest('li');
      var dropdown = listItem.querySelector('.megamenu__dropdown');
      if (dropdown) {
        document.querySelectorAll('.megamenu__dropdown').forEach(d => {
          if (d !== dropdown) {
            d.classList.remove('active');
            d.closest('li').removeAttribute('data-toggle');
          }
        });
        dropdown.classList.toggle('active');
        if (dropdown.classList.contains('active')) {
          listItem.setAttribute('data-toggle', 'true');
        } else {
          listItem.removeAttribute('data-toggle');
        }
      }
    });
  });
  function resetDrawer() {
    drawer.querySelector('.megamenu__drawer-content').style.transform = 'translateX(0)';
    linkLevelTwo.forEach(eachItem => eachItem.style.transform = 'translateX(100%)');
    dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
  }
  document.addEventListener('click', e => {
    if (!drawer.contains(e.target) && !hamburgerBtn.contains(e.target)) {
      toggleDrawer(false);
    }
  });
};

// -------------search js------------------

var search = () => {
  var openModalButton = document.querySelector('[click-event-search]');
  var closeModalButton = document.querySelector('[click-event-close]');
  var modal = document.querySelector('[search-content-modal]');
  openModalButton === null || openModalButton === void 0 || openModalButton.addEventListener('click', function (event) {
    event.preventDefault();
    modal.style.display = 'block';
    modal.classList.add('open__modal');
    var searchContainer = document.querySelector('.megamenu__search-wrap');
    var searchHeight = searchContainer.clientHeight;
    document.documentElement.style.setProperty('--megamenu-search-height', searchHeight + 'px');
    document.body.classList.add('megamenu__search-no-scroll');
  });
  closeModalButton === null || closeModalButton === void 0 || closeModalButton.addEventListener('click', function () {
    modal.style.display = 'none';
    modal.classList.remove('open__modal');
    document.documentElement.style.setProperty('--megamenu-search-height', '0px');
    document.body.classList.remove('megamenu__search-no-scroll');
  });
};

// ----------client height of menu-----------

var clientHeight = () => {
  var announcement = document.querySelector('.announcement__wrapper');
  var header = document.querySelector('.megamenu__header');
  var desktopHeader = document.querySelector('.site-header');
  var desktopMegaMenuList = document.querySelector('.mega-menu-list');
  var announcementHeight = announcement.clientHeight - 1;
  var headerHeight = header.clientHeight;
  var desktopHeaderHeight = desktopHeader.clientHeight;
  var desktopMegaMenuListHeight = desktopMegaMenuList.clientHeight;
  document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
  document.documentElement.style.setProperty('--megamenu-header-height', headerHeight + 'px');
  document.documentElement.style.setProperty('--desktop-header-height', desktopHeaderHeight + 'px');
  document.documentElement.style.setProperty('--desktop-megamenu-list-height', desktopMegaMenuListHeight + 'px');
};

// -----------country selector----------------

var countrySelector = () => {
  var selectors = document.querySelectorAll('[data-selected-option]');
  var dropdowns = document.querySelectorAll('[data-option]');
  var arrows = document.querySelectorAll('.icon--type-arrow-down');
  selectors.forEach((selector, index) => {
    selector.addEventListener('click', function (event) {
      event.preventDefault();
      dropdowns.forEach((dropdown, dropdownIndex) => {
        if (index === dropdownIndex) {
          dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
        } else {
          dropdown.style.display = 'none';
        }
      });
      arrows.forEach((arrow, arrowIndex) => {
        if (index === arrowIndex) {
          arrow.classList.toggle('rotate-180');
        } else {
          arrow.classList.remove('rotate-180');
        }
      });
    });
  });
};

// -----------mega menu header hover----------------

var MegaMenuHover = () => {
  var menuItems = document.querySelectorAll('[data-menu-parent] [data-menu-child]');
  var megaMenu = document.querySelector('.mega-menu-list');
  menuItems.forEach(item => {
    var link = item.querySelector('[data-menu-link]');
    var toggleClasses = add => {
      if (item.classList.contains('site-nav__item--has-child') || item.classList.contains('site-nav__item--mega')) {
        var method = add ? 'add' : 'remove';
        megaMenu.classList[method]('header__mega-active');
        item.classList[method]('site-nav__item--active');
        document.body.classList[method]('mega-menu--open');
        var siteNav = item.closest('.site-nav');
        if (siteNav) siteNav.classList[method]('site-nav__main--active');
        if (link) link.classList[method]('site-nav__link--active');
      }
    };
    item.addEventListener('mouseenter', () => toggleClasses(true));
    item.addEventListener('mouseleave', () => toggleClasses(false));
  });
};

// -----------mega menu header hover----------------

var MegaMenuScroll = () => {
  var prevScrollpos = window.scrollY;
  var megaMenuList = document.querySelector('.mega-menu-list');
  var announcementWrapper = document.querySelector('.announcement__wrapper');
  var megaMenuListHeight = megaMenuList.offsetHeight;
  var announcementWrapperHeight = announcementWrapper.offsetHeight;
  var scrollDistance = megaMenuListHeight + announcementWrapperHeight;
  window.addEventListener('scroll', function () {
    var currentScrollPos = window.scrollY;
    if (prevScrollpos > currentScrollPos && currentScrollPos > scrollDistance) {
      megaMenuList.classList.remove('menu-list-hidden');
    } else if (currentScrollPos > scrollDistance) {
      megaMenuList.classList.add('menu-list-hidden');
    }
    prevScrollpos = currentScrollPos;
  });
};

// -----------mega menu header rewards button redirection----------------

var MenuRewardsButton = () => {
  var mobileDrawer = document.querySelector('.megamenu__drawer');
  var handleScroll = (section, offset) => {
    if (section) {
      var sectionTop = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: sectionTop,
        behavior: 'auto'
      });
    }
  };
  document.querySelectorAll('[data-rewards-button]').forEach(button => {
    button.addEventListener('click', () => {
      var section = document.querySelector('.section-newsletter');
      if (window.innerWidth <= 1200 && mobileDrawer !== null && mobileDrawer !== void 0 && mobileDrawer.classList.contains('open')) {
        mobileDrawer.classList.remove('open');
        document.body.classList.remove('megamenu__no-mobile-scroll');
        handleScroll(section, 20);
      } else {
        handleScroll(section, 170);
      }
    });
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  drawer();
  search();
  clientHeight();
  MegaMenuHover();
  MegaMenuScroll();
  MenuRewardsButton();
  if (window.innerWidth < 1200) {
    countrySelector();
  }
});

/***/ }),

/***/ "./js/components/registerCustomElements.js":
/*!*************************************************!*\
  !*** ./js/components/registerCustomElements.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_custom_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/custom-carousel */ "./js/components/custom-carousel.js");
/* harmony import */ var JsComponents_article_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/article-carousel */ "./js/components/article-carousel.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  customElements.define('custom-carousel', JsComponents_custom_carousel__WEBPACK_IMPORTED_MODULE_0__["default"]);
  customElements.define('article-carousel', JsComponents_article_carousel__WEBPACK_IMPORTED_MODULE_1__["default"]);
});

/***/ }),

/***/ "./js/sections/global.js":
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var JsComponents_registerCustomElements__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/registerCustomElements */ "./js/components/registerCustomElements.js");
/* harmony import */ var JsComponents_megamenu_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/megamenu-header */ "./js/components/megamenu-header.js");


document.addEventListener('DOMContentLoaded', () => {
  (0,JsComponents_registerCustomElements__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,JsComponents_megamenu_header__WEBPACK_IMPORTED_MODULE_1__["default"])();
  if (window.handleLayoutSwitch) {
    window.handleLayoutSwitch();
  }
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"global": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./js/sections/global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;